(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  function fixCtaGap(grid) {
    // Restore any previously promoted card back to after the CTA
    var promoted = grid.querySelector('.essentials-card[data-cta-promoted]');
    if (promoted) {
      var ctaEl = grid.querySelector('.essentials-cta-panel');
      if (ctaEl) grid.insertBefore(promoted, ctaEl.nextSibling);
      promoted.removeAttribute('data-cta-promoted');
    }

    if (!mq.matches) return;

    var cta = grid.querySelector('.essentials-cta-panel');
    if (!cta) return;

    var ctaIndex = Array.prototype.indexOf.call(grid.children, cta);
    if (ctaIndex % 2 === 1) {
      // Odd index means one empty cell would precede the full-width CTA.
      // Pull the first card after the CTA forward to fill that gap.
      var nextCard = cta.nextElementSibling;
      if (nextCard && nextCard.classList.contains('essentials-card')) {
        nextCard.setAttribute('data-cta-promoted', 'true');
        grid.insertBefore(nextCard, cta);
      }
    }
  }

  function runAll() {
    document.querySelectorAll('.essentials-grid').forEach(fixCtaGap);
  }

  document.addEventListener('DOMContentLoaded', function () {
    runAll();

    var productsGrid = document.querySelector('[data-products-grid]');
    if (productsGrid) {
      new MutationObserver(runAll).observe(productsGrid, { childList: true });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(runAll, 150);
    });
  });
})();
